export type ImpactType = {
  title: string;
  description: string;
  link: string;
};

export const IMPACT: ImpactType[] = [
  {
    title: "dna.policy.title",
    link: "/development",
    description: "dna.policy.description",
  },
  {
    title: "dna.initiatives.title",
    link: "/social",
    description: "dna.initiatives.description",
  },
];
